import { Modal } from 'antd';
import { WarningOutlined } from '@ant-design/icons';

const EHRResponseModal = ({ isVisible, onConfirm, onCancel, response }) => {
  const getErrorMessage = (code, message) => {
    switch (code) {
      case 'EHR_002':
        return 'Chart must remain open from check-in to signature. If you proceed, the document will be submitted as a complete document under encounter section.';
      case 'EHR_001':
        return `${message}. \nIf you proceed, the document will be submitted as a complete document under encounter section.`;
      case 'EHR_003':
        return `${message}`;
      case 'EHR_004':
        return `${message}`;
      default:
        return 'An error occurred while saving to EHR';
    }
  };
  return (
    <>
      {response &&
      (response.code === 'EHR_002' || response.code === 'EHR_001') ? (
        <Modal
          title={
            <span>
              <WarningOutlined
                style={{ color: '#faad14', marginRight: '8px' }}
              />
              Note will be submitted as a complete document
            </span>
          }
          visible={isVisible}
          onOk={onConfirm}
          closable={false}
          onCancel={onCancel}
          className="error-modal"
        >
          <p style={{ whiteSpace: 'pre-line' }}>
            {response && (
              <>
                {getErrorMessage(response.code, response.message)}
                {response.message && (
                  <div className="mt-2">
                    {/* <strong>Details: {response.message}</strong> */}
                  </div>
                )}
              </>
            )}
          </p>
        </Modal>
      ) : (
        <Modal
          title={
            <span>
              <WarningOutlined
                style={{ color: '#faad14', marginRight: '8px' }}
              />
              Error while submitting to EHR
            </span>
          }
          visible={isVisible}
          onOk={onCancel}
          closable={false}
          onCancel={onCancel}
          className="error-modal"
        >
          <p style={{ whiteSpace: 'pre-line' }}>
            {response && (
              <>
                {getErrorMessage(response.code, response.message)}
                {response.message && (
                  <div className="mt-2">
                    {/* <strong>Details: {response.message}</strong> */}
                  </div>
                )}
              </>
            )}
          </p>
        </Modal>
      )}
    </>
  );
};

export default EHRResponseModal;
